(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canvelle-irl-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cv-irl-video')) {
    customElements.define(
      'cv-irl-video',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('.cv-irl__play')?.addEventListener('click', () => this.load(), { once: true });
        }

        load() {
          const video = this.querySelector('template')?.content.firstElementChild?.cloneNode(true);
          if (!(video instanceof HTMLVideoElement)) return;

          for (const other of document.querySelectorAll('cv-irl-video video')) other.pause();

          // The poster stays up until the first frame, then the video fades in.
          // If play() is refused, show the video anyway so its controls can start it.
          const reveal = () => {
            this.removeAttribute('loading');
            this.setAttribute('playing', '');
          };
          video.addEventListener('playing', reveal, { once: true });
          this.setAttribute('loading', '');
          this.append(video);
          video.play()?.catch(reveal);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
